import { createApp, type Directive } from 'vue'

import App from './App.vue'
import FocusTrap from 'primevue/focustrap'
import install from '@/install'

import './styles/index.sass'
import './styles/theme.css' // Import new design tokens
import './registerServiceWorker'

import 'vue-final-modal/style.css'
import './styles/vfm-overrides.scss'

const app = createApp(App)
app.directive('focustrap', FocusTrap as Directive)
app.use(install)
app.mount('#app')
// firebase deploy --only hosting:qbeek-admin-preprod
